import React from "react"
import { AppFunctionComponent } from "../../../types"
import logo from "../../../images/layout/logo.svg"
import MobileMenu from "../../components/mobile-menu/mobile-menu.component"
import NavigationList from "../../components/navigation-list/navigation-list.component"
import Submenu from "../../components/submenu/submenu.component"
import Controls from "../../../components/common/controls-area/controls-area.component"
import {
  HamburgerControl,
  HeaderContainer,
  HeaderSection,
  HeaderSectionWraper,
  HeaderWrapper,
  KickstarterHeaderSection,
  KickstarterHeaderWrapper,
  Logo,
  LogoLink,
} from "./header.styled"
import { SubmenuItem } from "../../types/header.interface"
import { Path } from "../../constants/routes"
import SimpleLanguagePicker from "../../../components/common/simple-language-picker/simple.language-picker.component"
import { KICKSTARTER_PAGE_PATH } from "../../../constants/kickstarter"

interface Props {
  siteTitle: string
  pathname: string
  navItems: SubmenuItem[]
  mobileMenuOpened: boolean
  openMenu: () => void
  onLogoTap: () => void
  path: Path
}

const HeaderBase: AppFunctionComponent<Props> = ({
  siteTitle = "",
  pathname,
  navItems,
  mobileMenuOpened,
  openMenu,
  onLogoTap,
  path,
}) => {
  const landing = pathname.includes(KICKSTARTER_PAGE_PATH)
  return landing ? (
    <>
      <KickstarterHeaderWrapper>
        <HeaderSectionWraper>
          <KickstarterHeaderSection>
            <div>
              <LogoLink to={path} onTouchEnd={onLogoTap}>
                <Logo src={logo} alt={`${siteTitle} homepage`} />
              </LogoLink>
            </div>
            <SimpleLanguagePicker />
          </KickstarterHeaderSection>
        </HeaderSectionWraper>
      </KickstarterHeaderWrapper>
    </>
  ) : (
    <>
      <HeaderWrapper className="main-header">
        <HeaderSectionWraper>
          <HeaderSection>
            <HeaderContainer aria-label={"Main pages"}>
              <LogoLink to={path} onTouchEnd={onLogoTap}>
                <Logo src={logo} alt={`${siteTitle} homepage`} />
              </LogoLink>
              <NavigationList navigationItems={navItems} pathname={pathname} />
              <Controls>
                <HamburgerControl
                  active={mobileMenuOpened}
                  onClick={openMenu}
                />
              </Controls>
            </HeaderContainer>
            <MobileMenu opened={mobileMenuOpened} navigationItems={navItems} />
          </HeaderSection>
        </HeaderSectionWraper>
      </HeaderWrapper>
      <Submenu navigationItems={navItems} pathname={pathname} />
    </>
  )
}

export default HeaderBase
